import React, { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import ScrollToTopButton from "../ScrollToTopButton";

const BlogPage1 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className="blogdetails-mainsection">
                <ScrollToTopButton />
                <div className='container-fluid'>
                    <div className='aboutus-bgsection'>
                        <div className='container'>
                            <h2 className='aboutus-header'>Blog Details</h2>
                            <div>
                                <h3 className='pages-head'> <Link to={'/'} aria-label="Blog" className="about-s">HOME</Link> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' /><NavLink to={'/Blog'} aria-label="blog" className="about-s">Blog</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />Blog Details</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="blogdetails-section2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="blogdetails-leftsection">
                                    <img className="blogdetails-leftsectionim" src="../assets/images/img-post4.jpg" alt="blog" />
                                    <p className="blogdetails-leftsectiondate">17 Mar, 2025</p>
                                    <h3 className="blogdetails-leftsectionHead">Challenges of a new technology business in Year 2024.</h3>
                                    <p className="blogdetails-leftsectionText">We are committed to offering the best technology services to meet your unique needs. We 4Sight Tech understand that plumbing issues can be disruptive and stressful, which is why we go above and beyond to deliver exceptional service that surpasses your expectations.</p>
                                    <p className="blogdetails-leftsectionText">These are the concepts that shape our distinctive culture & differentiate us from others. They true the unique spirit of our Firm guide the behaviors that enable us to deliver the promises we make to our clients and our people.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="blogdetails-rightsection">
                                    <h3 className="blogdetails-rightsectionHead">Recent Posts</h3>
                                    <div className="line"></div>
                                    <NavLink style={{ textDecoration: 'none' }} aria-label="Blog" to={'/'}>
                                        <div className="d-flex align-items-center blogdetails-rightsectionimgsec">
                                            <div className="flex-shrink-0">
                                                <img className="blogdetails-rightsectionim" src="../assets/images/blog4.jpg" alt="blog" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h3 className="blogdetails-rightsectionimhead">The future of headset among Youngsters</h3>
                                                <p className="blogdetails-rightsectionimtxt">17 Mar, 2025</p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink style={{ textDecoration: 'none' }} aria-label="Blog" to={'/'}>
                                        <div className="d-flex align-items-center blogdetails-rightsectionimgsec">
                                            <div className="flex-shrink-0">
                                                <img className="blogdetails-rightsectionim" src="../assets/images/blog2.webp" alt="blog" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h3 className="blogdetails-rightsectionimhead">New plugins for creating new charts in dashboard</h3>
                                                <p className="blogdetails-rightsectionimtxt">17 Mar, 2025</p>
                                            </div>
                                        </div>
                                    </NavLink>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BlogPage1;